'use client'

import { Toaster as SonnerToaster } from 'sonner'
import styles from './toast.module.scss'

export const Toaster = () => {
  return (
    <SonnerToaster
      className={styles.soonerWrapperColor}
      theme="light"
      toastOptions={{
        style: {
          bottom: -11,
          background: 'var(--toast-background, var(--color-invert-shade))',
          border: '1px solid var(--toast-border, var(--color-invert-border))',
          borderRadius: 8,
          padding: '12px 16px',
          fontSize: 13,
          lineHeight: 1.5,
          color: 'var(--toast-text-color, var(--color-invert-base))',
          display: 'grid',
          gridTemplateColumns: 'auto 1fr',
          // enables the following layout: icon / text
          //                                     button
          alignItems: 'flex-start',
        },
        className:
          '[&>[data-icon]]:mt-0.5 [&>[data-button]]:col-span-full [&>[data-button]]:!bg-dark-base [&>[data-button]]:!text-dark-bright',
        // '[&>[data-button]]:!cursor-default [&>[data-button]:hover]:!bg-dark-shade-hover'
      }}
    />
  )
}
